global.API_URL = process.env.API_ROOT  // 访问方才保存的链接
global.GT1_URL = process.env.GT1_ROOT  // 访问方才保存的链接
global.SSO_PORTAL = process.env.SSO_PORTAL  // 访问方才保存的链接
global.ADMIN_KEY = "silverliningadmin" //管理员访问密码
global.cookieName = "userNameSme"
global.companyId = "companyIdSme"
global.securityLogRetentionTime = "securityLogRetentionTime"

global.store = {
  source: {
    token: null,
    cancel: null
  }
}



// WEBPACK FOOTER //
// ./src/utils/global.js